import * as ActionType from "./contant";

const initState = {
  activeTab: "5",
};

const reducer = (state = initState, action) => {
  const { type, value } = action;

  switch (type) {
    case ActionType.SET_ACTIVETAB:
      return {
        ...state,
        activeTab: value,
      };
    case ActionType.CLEAR_ACTIVETAB:
      return initState;
    default:
      return state;
  }
};

export default reducer;
